import { createSelector } from 'reselect';
import {
  MapElementView,
  MapView,
  TerrainView,
} from '@Selectors/ninthage/view/map.view';
import { getMap } from '@Selectors/ninthage/selector/getMap';
import { MapElementOrientation } from '@Models';

const findOrientation = (orientation: MapElementOrientation): number => {
  switch (orientation) {
    case MapElementOrientation.VERTICAL:
      return 90;
    case MapElementOrientation.DIAGONAL_TOP:
      return 45;
    case MapElementOrientation.DIAGONAL_BOTTOM:
      return 135;
    default:
      return 0;
  }
};

export const mapPresenter = createSelector([getMap], (map): MapView | null => {
  if (!map) {
    return null;
  }

  return {
    id: map.id,
    initials: map.initials,
    name: map.name,
    description: map.description,
    logo: map.logo,
    width: 72,
    height: 48,
    elements: map.elements
      .filter((element) => element.terrain.logo)
      .map((element) => {
        const orientation = findOrientation(element.orientation);
        return {
          name: element.terrain.name,
          top: element.top,
          left: element.left,
          right: element.right,
          bottom: element.bottom,
          rotation: orientation,
          width: element.terrain.width / 2.54,
          height: element.terrain.height / 2.54,
          logo: element.terrain.logo!,
        } satisfies MapElementView as MapElementView;
      }),
    terrains: map.elements
      .map((element) => element.terrain)
      .filter((terrain) => terrain.logo)
      .filter(
        (terrain, index, self) =>
          self.findIndex((t) => t.id === terrain.id) === index,
      )
      .map(
        (terrain) =>
          ({
            id: terrain.id,
            name: terrain.name,
            size: terrain.size,
            logo: terrain.logo!,
          }) satisfies TerrainView as TerrainView,
      ),
  } satisfies MapView as MapView;
});
